import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const SEL = "mt-1 w-full rounded-xl border-2 border-[var(--brand-border)] px-4 py-2.5 text-sm outline-none focus:border-[var(--brand-accent)] bg-white";
export const ESTADOS_CON_CIERRE = ["contratado", "descartada"];

// Captures the internal closing data (modo de contratación / motivo) before saving the state change.
export const CierreDialog = ({ pending, onCancel, onConfirm }) => {
  const [ops, setOps] = useState(null);
  const [v, setV] = useState({ modo_contratacion: "", motivo: "", motivo_detalle: "" });

  useEffect(() => {
    api.get("/empresa/opciones-postulacion").then((r) => setOps(r.data)).catch(() => toast.error("No se pudieron cargar las opciones"));
  }, []);
  useEffect(() => { setV({ modo_contratacion: "", motivo: "", motivo_detalle: "" }); }, [pending]);

  const contratado = pending?.estado === "contratado";
  const otro = ops && v.motivo === ops.motivo_otro;
  const valido = contratado ? !!v.modo_contratacion : !!v.motivo && (!otro || v.motivo_detalle.trim());

  const confirmar = (e) => {
    e.preventDefault();
    if (!valido) return;
    onConfirm(contratado ? { modo_contratacion: v.modo_contratacion } : { motivo: v.motivo, motivo_detalle: otro ? v.motivo_detalle.trim() : "" });
  };

  return (
    <Dialog open={!!pending} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent data-testid="cierre-dialog">
        <DialogHeader>
          <DialogTitle>{contratado ? "Marcar como contratado/a" : "Marcar como No avanza"}</DialogTitle>
          <DialogDescription>{contratado ? "¿Cómo fue la contratación? Es un dato interno: no se le muestra al egresado/a." : "Contanos el motivo. Es un dato interno: no se le muestra al egresado/a."}</DialogDescription>
        </DialogHeader>
        <form onSubmit={confirmar} noValidate className="space-y-4">
          {contratado ? (
            <label className="block"><span className="text-xs font-semibold text-[var(--brand-primary)]">Modo de contratación</span>
              <select className={SEL} value={v.modo_contratacion} onChange={(e) => setV({ ...v, modo_contratacion: e.target.value })} data-testid="cierre-modo">
                <option value="">Elegí una opción…</option>
                {ops?.modos_contratacion.map((p) => <option key={p} value={p}>{p}</option>)}
              </select>
            </label>
          ) : (
            <>
              <label className="block"><span className="text-xs font-semibold text-[var(--brand-primary)]">Motivo</span>
                <select className={SEL} value={v.motivo} onChange={(e) => setV({ ...v, motivo: e.target.value })} data-testid="cierre-motivo">
                  <option value="">Elegí un motivo…</option>
                  {ops?.motivos_no_avanza.map((m) => <option key={m} value={m}>{m}</option>)}
                </select>
              </label>
              {otro && (
                <label className="block"><span className="text-xs font-semibold text-[var(--brand-primary)]">Especificá el motivo</span>
                  <textarea maxLength={300} rows={3} className={SEL} value={v.motivo_detalle} onChange={(e) => setV({ ...v, motivo_detalle: e.target.value })} data-testid="cierre-motivo-detalle" />
                </label>
              )}
            </>
          )}
          <div className="flex justify-end gap-2">
            <button type="button" className="btn-outline" onClick={onCancel} data-testid="cierre-cancelar">Cancelar</button>
            <button type="submit" className="btn-primary" disabled={!valido} data-testid="cierre-confirmar">Guardar</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
